import {Typography} from '@mui/material';
import {DlMuiChip, DlMuiPopper, useMuiAnchor} from '@wallaby-ui/core';
import * as React from 'react';

type Props<T> = {
  style?: React.CSSProperties;
  chipStyle?: React.CSSProperties;
  value?: T[];
  getInfo: (singleValue: T) => {label?: string; color?: string; background?: string};
  tooltip?: string | JSX.Element;
};
export const ChipsFormatter = <T,>(props: Props<T>): JSX.Element => {
  const {style, chipStyle, value, getInfo, tooltip} = props;

  const hasTooltip = Boolean(tooltip);
  const {mouseEventEnter, mouseEventLeave, open, anchorEl} = useMuiAnchor(hasTooltip);

  return (
    <div
      style={{marginBottom: 2, lineHeight: 1, display: 'inline-block', maxWidth: '100%', ...style}}
      onMouseEnter={mouseEventEnter}
      onMouseLeave={mouseEventLeave}
    >
      <div
        style={{display: 'inline-flex', maxWidth: '100%', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 4, flexWrap: 'wrap'}}
      >
        {(value ?? []).map((singleValue, i) => {
          const {label, color = 'var(--dlTheme-800)', background = 'var(--dlThemeGray-50)'} = getInfo(singleValue);
          return <DlMuiChip key={i} label={label ?? ''} style={{maxWidth: '100%', background, color, ...chipStyle}} />;
        })}
      </div>
      <DlMuiPopper hasTooltip={hasTooltip} anchorEl={anchorEl} open={open}>
        <Typography variant={'popper'}>{tooltip}</Typography>
      </DlMuiPopper>
    </div>
  );
};
